import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import CampaignDonation from '../pages/public/Campaign/CampaignDonation';
import Login from '../pages/public/Login';
import Dashboard from '../pages/admin/Dashboard';
import PrivateRoute from './PrivateRoute';
import { ViewProvider } from '../components/layout/ViewContext'; // Import ViewProvider
import ForgotPassword from '../pages/public/ForgotPassword';
import ResetPassword from '../pages/public/ResetPassword';
import CompanyInfoList from '../pages/admin/companyInfo/List';
import CompanyInfoCreate from '../pages/admin/companyInfo/Create';
import CompanyInfoEdit from '../pages/admin/companyInfo/Edit';
import UsersList from '../pages/admin/users/List';
import UserCreate from '../pages/admin/users/Create';
import UserEdit from '../pages/admin/users/Edit';
import AuditLogList from "../pages/admin/auditLogs/List";
import Unsubscribe from "../pages/public/Unsubscribe";
import BulkEmailList from "../pages/admin/bulkEmail/List";
import BulkEmailCreate from "../pages/admin/bulkEmail/Create";
import BulkEmailEdit from "../pages/admin/bulkEmail/Edit";

import MemberList from '../pages/admin/member/List';
import MemberCreate from '../pages/admin/member/Create';
import MemberEdit from '../pages/admin/member/Edit';

import QuestionSetList from '../pages/admin/questionSet/List';
import QuestionSetCreate from '../pages/admin/questionSet/Create';
import QuestionSetEdit from '../pages/admin/questionSet/Edit';

import RewardList from '../pages/admin/reward/List';
import RewardCreate from '../pages/admin/reward/Create';
import RewardEdit from '../pages/admin/reward/Edit';

import CampaignList from '../pages/admin/campaign/List';
import CampaignCreate from '../pages/admin/campaign/Create';
import CampaignEdit from '../pages/admin/campaign/Edit';

import PaymentList from '../pages/admin/payment/List';
import PaymentEdit from '../pages/admin/payment/Edit';
import DonationRedirect from '../pages/public/Campaign/DonationRedirect';
import DebitOrderRedirect from '../pages/public/Campaign/DebitOrderRedirect';

import PaymentStatusRedirect from '../pages/public/Campaign/PaymentStatusRedirect';

import BankList from '../pages/admin/bank/List';
import BankCreate from '../pages/admin/bank/Create';
import BankEdit from '../pages/admin/bank/Edit';

// Import route here

const AppRouter = () => {
    return (
        <ViewProvider>
            {' '}
            {/* Wrap all routes in the ViewProvider */}
            <Router>
                <Routes>
                    <Route path="/" element={<Login />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/unsubscribe" element={<Unsubscribe />} />
                    <Route path="/campaign-donation/:campaignId" element={<CampaignDonation />} />
                    <Route path="/campaign-donation/redirect/:paymentId" element={<DonationRedirect />} />
                    <Route path="/campaign-donation-debit-order/redirect/:campaignId" element={<DebitOrderRedirect />} />
                    <Route path="/payment/return/:paymentId" element={<PaymentStatusRedirect />} />

                    {/* Protected admin routes */}
                    <Route
                        path="/admin/dashboard"
                        element={
                            <PrivateRoute>
                                <Dashboard />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/auditlogs"
                        element={
                            <PrivateRoute>
                                <AuditLogList />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/companyinfo"
                        element={
                            <PrivateRoute>
                                <CompanyInfoList />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/companyinfo/create"
                        element={
                            <PrivateRoute>
                                <CompanyInfoCreate />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/companyinfo/:id"
                        element={
                            <PrivateRoute>
                                <CompanyInfoEdit />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/admin/bulkemails"
                        element={
                            <PrivateRoute>
                                <BulkEmailList />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/bulkemails/create"
                        element={
                            <PrivateRoute>
                                <BulkEmailCreate />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/bulkemails/:id"
                        element={
                            <PrivateRoute>
                                <BulkEmailEdit />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/admin/users"
                        element={
                            <PrivateRoute>
                                <UsersList />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/users/create"
                        element={
                            <PrivateRoute>
                                <UserCreate />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/users/:id"
                        element={
                            <PrivateRoute>
                                <UserEdit />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/admin/members"
                        element={
                            <PrivateRoute>
                                <MemberList />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/members/create"
                        element={
                            <PrivateRoute>
                                <MemberCreate />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/members/:id"
                        element={
                            <PrivateRoute>
                                <MemberEdit />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/admin/questionsets"
                        element={
                            <PrivateRoute>
                                <QuestionSetList />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/questionsets/create"
                        element={
                            <PrivateRoute>
                                <QuestionSetCreate />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/questionsets/:id"
                        element={
                            <PrivateRoute>
                                <QuestionSetEdit />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/admin/rewards"
                        element={
                            <PrivateRoute>
                                <RewardList />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/rewards/create"
                        element={
                            <PrivateRoute>
                                <RewardCreate />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/rewards/:id"
                        element={
                            <PrivateRoute>
                                <RewardEdit />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/admin/campaigns"
                        element={
                            <PrivateRoute>
                                <CampaignList />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/campaigns/create"
                        element={
                            <PrivateRoute>
                                <CampaignCreate />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/campaigns/:id"
                        element={
                            <PrivateRoute>
                                <CampaignEdit />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/admin/payments"
                        element={
                            <PrivateRoute>
                                <PaymentList />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/admin/payments/:id"
                        element={
                            <PrivateRoute>
                                <PaymentEdit />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/admin/banks"
                        element={
                            <PrivateRoute>
                                <BankList/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/banks/create"
                        element={
                            <PrivateRoute>
                                <BankCreate/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/banks/:id"
                        element={
                            <PrivateRoute>
                                <BankEdit/>
                            </PrivateRoute>
                        }
                    />






                </Routes>
            </Router>
        </ViewProvider>
    );
};

export default AppRouter;
